import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import EditBankAccountForm from '../EditBankAccountForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'
export default function EditBankAccountListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`แก้ไขบัญชีธนาคาร`} description="แก้ไขบัญชีธนาคาร" />
				<NavigateBackButton />
			</div>
			<Separator />
			<EditBankAccountForm />
		</div>
	)
}
